export interface MasterPageResult<T = any> {
  items: T[];
  total: number;
  raw: any;
}

function firstArrayValue(value: any): any[] | null {
  if (Array.isArray(value)) {
    return value;
  }
  return null;
}

function findArrayProperty(obj: any): any[] | null {
  if (!obj || typeof obj !== 'object') {
    return null;
  }

  const preferredKeys = ['records', 'items', 'data'];
  for (const key of preferredKeys) {
    const found = firstArrayValue(obj[key]);
    if (found) {
      return found;
    }
  }

  const keys = Object.keys(obj);
  for (const key of keys) {
    if (/list$/i.test(key)) {
      const found = firstArrayValue(obj[key]);
      if (found) {
        return found;
      }
    }
  }

  for (const key of keys) {
    const found = firstArrayValue(obj[key]);
    if (found) {
      return found;
    }
  }

  return null;
}

export function extractMasterPage<T = any>(res: any): MasterPageResult<T> {
  const raw = res?.data ?? res?.response ?? res?.result ?? res ?? {};
  const response = res?.response ?? res?.data ?? {};

  const items =
    firstArrayValue(raw) ??
    firstArrayValue(response) ??
    firstArrayValue(raw?.records) ??
    firstArrayValue(raw?.items) ??
    firstArrayValue(response?.records) ??
    firstArrayValue(response?.items) ??
    findArrayProperty(raw) ??
    findArrayProperty(response) ??
    [];

  const total =
    Number(raw?.totalRecords ?? raw?.total ?? response?.totalRecords ?? response?.total ?? items.length) || 0;

  return {
    items: items as T[],
    total,
    raw,
  };
}
